/**
 * TaskNoteService
 * Service for TaskNote entity operations
 * Route: api/task-note
 */
import { CrudService } from '../base/CrudService';
/**
 * TaskNoteService
 * Handles task note CRUD operations
 */
export class TaskNoteService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? TaskNoteService.DEFAULT_SERVICE_PATH,
            basePath: TaskNoteService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET BY TASK ID ====================
    /**
     * Get all notes for a task
     * GET api/task-note/task/{taskId}
     */
    async getByTaskId(taskId) {
        const response = await this.getByTaskIdRaw(taskId);
        return response.data ?? [];
    }
    /**
     * Get all notes for a task with full response
     */
    getByTaskIdRaw(taskId) {
        const endpoint = this.getEndpoint('by-task', `task/${taskId}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
}
TaskNoteService.DEFAULT_SERVICE_PATH = 'tasks';
TaskNoteService.BASE_PATH = 'api/task-note';
//# sourceMappingURL=TaskNoteService.js.map